export default "__VITE_ASSET__7372d785__"